// utils/isElectric.js
// true iff:
//  - fueltype === "elektrisch" (normalisiert, case-insensitive)
//  - createdAt >= 2025-11-01T00:00:00+01:00 (CET)

function stripDiacritics(str) {
  return String(str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function normalize(str) {
  return stripDiacritics(str).toLowerCase().replace(/\s+/g, " ").trim();
}

// Midnight CET after Oct 31, 2025
const CUTOFF_MS = Date.parse("2025-10-31T00:00:00+01:00");

// Firestore Timestamp -> ms
function tsToMillis(ts) {
  if (!ts) return NaN;
  if (typeof ts.toDate === "function") return ts.toDate().getTime();
  if (typeof ts.seconds === "number") {
    const nanos = typeof ts.nanoseconds === "number" ? ts.nanoseconds : 0;
    return ts.seconds * 1000 + Math.floor(nanos / 1e6);
  }
  if (typeof ts._seconds === "number") {
    const nanos = typeof ts._nanoseconds === "number" ? ts._nanoseconds : 0;
    return ts._seconds * 1000 + Math.floor(nanos / 1e6);
  }
  return NaN;
}

export function isElectric(carData) {
  if (!carData) return false;

  // 1) elektrisch?
  if (normalize(carData.fueltype || "") !== "elektrisch") return false;

  // 2) Stichtag erfüllt?
  const createdMs = tsToMillis(carData.createdAt);
  if (!Number.isFinite(createdMs)) return false;

  return createdMs >= CUTOFF_MS;
}
